import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { parse } from 'query-string';
import axios from 'axios';
import { FragmentConfiguration } from '@/config';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import useUrlParameters from '../useUrlParameters';

export const useOutcome = (): void => {
  const { hash } = useLocation();
  const { 'br-exp': brExp } = parse(hash);
  const { tracking } = useConfig<FragmentConfiguration>();
  // eslint-disable-next-line dot-notation
  const url = useUrlParameters(tracking.values.brOutcomeUrl, {}, true);
  useEffect(() => {
    if (url && brExp) {
      axios.get(`${url}?TestName=${brExp}`);
    }
  }, [brExp]);
};

export default useOutcome;
